import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import CallToAction from '../../../../shared/CallToAction/CallToAction';

import './LeadGenConsentStatements.scss';

export default function LeadGenConsentStatements(props) {
  const { color, leadGenType } = props;
  const articleLinkClass = classnames({
    'c-lead-gen-consent-statements__link-article': leadGenType === 'article',
  });

  return (
    <div className="c-lead-gen-consent-statements">
      <div className="c-lead-gen-consent-statements__policy">
        You can opt out of any time clicking unsubscribe or contacting us or the
        sender. For further details, see our{' '}
        <CallToAction
          type="link"
          target="_blank"
          to="https://www.informa.com/privacy-policy"
          className={articleLinkClass}
          style={{ color }}
        >
          Privacy Notice
        </CallToAction>
      </div>
    </div>
  );
}

LeadGenConsentStatements.propTypes = {
  tenantName: PropTypes.string,
  color: PropTypes.string,
  leadGenType: PropTypes.string,
};
